/// <amd-module name="Wit/BoardsHub/Common/IBoardsWorkItemStateService" />
 
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IWorkItemTrackingRestClient } from "Wit/Clients/Wit/RestClient/WorkItemTracking.Types";
import * as WorkItemTracking from "Wit/Clients/Wit/Contracts/WorkItemTracking";

export interface IBoardsWorkItemStateService extends IVssService {
    /**
     * Get states for given WorkItem types category
     */
    getWorkItemTypeStates(projectName: string, workItemType: string, category: string): string[] | Promise<string[]>;
}

class BoardsWorkItemStateService extends VssService implements IBoardsWorkItemStateService{
    
    private _cachedWorkItemStatesPromises: { [projectName: string]: { [itemType: string] : Promise<WorkItemTracking.WorkItemStateColor[]> } } = {};
    private _cachedWorkItemStates: { [projectName: string]: { [itemType: string] : { [category: string]: WorkItemTracking.WorkItemStateColor[] } } } = {};
    
    public _serviceStart(pageContext: IVssPageContext) {
        super._serviceStart(pageContext);
    }

    getWorkItemTypeStates(projectName: string, workItemType: string, category: string): string[] | Promise<string[]>{
        if (!workItemType || !category) {
            return [];
        }

        this.checkKnownProject(projectName);

        if (this._cachedWorkItemStates[projectName][workItemType]){
            return this.getCachedStateNames(projectName, workItemType, category);
        }     

        if (!this._cachedWorkItemStatesPromises[projectName][workItemType]){
            this.makeStatesRequest(projectName, workItemType);
        }   

        return this._cachedWorkItemStatesPromises[projectName][workItemType]
            .then(workItemTypeStates => {
                this.cacheNewStates(projectName, workItemType, workItemTypeStates);
                return this.getCachedStateNames(projectName, workItemType, category);
            })
            .catch(() => {
                this._cachedWorkItemStates[projectName][workItemType] = {};
                return [];
            })

    }


    private getCachedStateNames(projectName: string, workItemType: string, category: string): string[] {
        return this._cachedWorkItemStates[projectName][workItemType][category].map(it => it.name);
    }

    private cacheNewStates(projectName: string, workItemType: string, workItemTypeStates: WorkItemTracking.WorkItemStateColor[]) {
        this._cachedWorkItemStates[projectName][workItemType] = {};

        workItemTypeStates.forEach(it => {
            if (!this._cachedWorkItemStates[projectName][workItemType][it.category]) {
                this._cachedWorkItemStates[projectName][workItemType][it.category] = [];
            }
            this._cachedWorkItemStates[projectName][workItemType][it.category].push(it);
        });
    }

    private makeStatesRequest(projectName: string, workItemType: string) {
        const client = this.pageContext.getRestClient<IWorkItemTrackingRestClient>("IWorkItemTrackingRestClient");
        this._cachedWorkItemStatesPromises[projectName][workItemType] = client.getWorkItemTypeStates(projectName, workItemType);
    }

    private checkKnownProject(projectName: string) {
        if (!this._cachedWorkItemStatesPromises[projectName]) {
            this._cachedWorkItemStatesPromises[projectName] = {};
        }
        if (!this._cachedWorkItemStates[projectName]) {
            this._cachedWorkItemStates[projectName] = {};
        }
    }
}

Services.add("IBoardsWorkItemStateService", { serviceFactory: BoardsWorkItemStateService });